import type { RecursoDoPlano } from '@levitas/contracts';
import { RECURSO_LABEL } from '@levitas/contracts';
import { Card } from '@levitas/ui';
import { Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useSessao } from '../../lib/usar-sessao';

/**
 * A tela de um recurso que o plano da igreja não abre (seção 11.1).
 *
 * O menu já esconde o destino, mas o endereço continua digitável — e quem
 * chega aqui por um link antigo merece a explicação, e não um erro. A recusa
 * que vale continua sendo a da API, que responde 402.
 */
export function ComRecurso({
  recurso,
  children,
}: {
  recurso: RecursoDoPlano;
  children: ReactNode;
}) {
  const { temRecurso, pode } = useSessao();

  if (temRecurso(recurso)) return <>{children}</>;

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-4 py-10">
      <Card>
        <div className="flex flex-col items-center gap-4 p-8 text-center" data-testid="recurso-do-plano">
          <span
            aria-hidden
            className="flex size-12 items-center justify-center rounded-full bg-[var(--cor-superficie-2)] text-[var(--cor-texto-suave)]"
          >
            <Lock className="size-6" />
          </span>

          <div className="flex flex-col gap-1">
            <h1 className="text-xl font-semibold text-[var(--cor-texto)]">
              {RECURSO_LABEL[recurso]} não está no plano da sua igreja
            </h1>
            <p className="text-sm text-[var(--cor-texto-suave)]">
              Nada foi perdido: o que já existe continua aqui. Para abrir esta parte do Levitas,
              veja os planos — dá para trocar a qualquer momento.
            </p>
          </div>

          {pode('billing:read') ? (
            <Link
              to="/assinatura"
              className="inline-flex h-11 min-h-11 items-center justify-center rounded-[var(--radius-md)] bg-[var(--brand)] px-4 text-sm font-medium text-[var(--brand-texto)] shadow-[var(--shadow-xs)] hover:bg-[var(--brand-forte)]"
            >
              Ver os planos
            </Link>
          ) : (
            <p className="text-sm text-[var(--cor-texto-suave)]">
              Fale com quem cuida da assinatura da igreja.
            </p>
          )}
        </div>
      </Card>
    </div>
  );
}
